/*
  Kiwi Ears · Sound Lab coming-soon interactions (Rene 2026-09-02).
  Ported from the Kiwi_Ears_Sound_Lab_Coming_Soon_Pages reference pack's
  app.js and re-scoped: each section root carries data-ke-page="soundstage|
  golden|eq" and every lookup runs inside that root, so the tools stay
  self-contained sections instead of assuming they own document/body. The
  pack's header/menu/modal/hub code is gone (the theme provides chrome), and
  the localStorage waitlist demo is gone too — the sections post a real
  Shopify customer form. Kept: the reveal observer, the toast, and the three
  tool prototypes (all visual-only, per the pack's honesty notes).
*/
(function () {
  'use strict';
  if (window.__kiwiSoundLab) return;
  window.__kiwiSoundLab = true;

  function init() {
    var toast = null;
    var toastTimer;
    function showToast(message) {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'ke-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
    }

    var observer = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
          });
        }, { threshold: 0.12 })
      : null;

    document.querySelectorAll('.ke-lab[data-ke-page]').forEach(function (root) {
      if (root.dataset.keBound) return;
      root.dataset.keBound = '1';
      var page = root.dataset.kePage;
      var $ = function (sel) { return root.querySelector(sel); };
      var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

      $$('[data-reveal]').forEach(function (el) { observer ? observer.observe(el) : el.classList.add('is-visible'); });

      /* ---- Soundstage Arena: presets + three spatial sliders drive the
             top-down SVG model. Visual only — no audio. ---- */
      if (page === 'soundstage') {
        var values = { width: 60, depth: 60, precision: 75 };
        var presets = {
          intimate: { width: 34, depth: 34, precision: 84 },
          natural: { width: 60, depth: 60, precision: 76 },
          expansive: { width: 90, depth: 76, precision: 68 }
        };
        var nodes = $$('.ke-source-node');
        var tier = function (v, low, high) { return v < low ? 'Focused' : v > high ? 'Expansive' : 'Natural'; };
        var updateArena = function () {
          var w = 120 + (values.width / 100) * 235;
          var d = 95 + (values.depth / 100) * 255;
          nodes.forEach(function (node) {
            var nx = parseFloat(node.dataset.nx), ny = parseFloat(node.dataset.ny);
            var x = 440 + nx * w;
            var y = 450 - ny * d;
            var halo = node.querySelector('.ke-source-halo');
            var core = node.querySelector('.ke-source-core');
            var label = node.querySelector('.ke-source-label');
            halo.setAttribute('cx', x); halo.setAttribute('cy', y); halo.setAttribute('r', 8 + (100 - values.precision) * 0.16);
            core.setAttribute('cx', x); core.setAttribute('cy', y); core.setAttribute('r', 4.4 + (100 - values.precision) * 0.018);
            label.setAttribute('x', x + 10); label.setAttribute('y', y + 4);
          });
          Object.keys(values).forEach(function (k) {
            var range = $('#' + k + 'Range'), out = $('#' + k + 'Output');
            if (range) range.value = values[k];
            if (out) out.textContent = values[k] + '%';
          });
          var widthText = tier(values.width, 45, 78);
          var depthText = tier(values.depth, 45, 75);
          var precisionText = values.precision > 80 ? 'Pinpoint' : values.precision > 64 ? 'Defined' : 'Diffuse';
          $('#stageSummaryTitle').textContent = widthText + ' stage · ' + precisionText + ' image';
          $('#stageSummaryText').textContent = widthText + ' lateral spread, ' + depthText.toLowerCase() + ' front-to-back layering, and ' + precisionText.toLowerCase() + ' source boundaries.';
        };
        ['width', 'depth', 'precision'].forEach(function (key) {
          var range = $('#' + key + 'Range');
          if (range) range.addEventListener('input', function () {
            values[key] = Number(range.value);
            $$('.ke-preset-row .ke-segment-button').forEach(function (b) { b.classList.remove('active'); });
            updateArena();
          });
        });
        $$('.ke-preset-row .ke-segment-button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            Object.assign(values, presets[btn.dataset.stage]);
            $$('.ke-preset-row .ke-segment-button').forEach(function (b) { b.classList.toggle('active', b === btn); });
            updateArena();
          });
        });
        updateArena();
      }

      /* ---- Golden Ears: curriculum tabs, lesson selection, and the
             four-step visual walkthrough. Not a hearing test. ---- */
      if (page === 'golden') {
        var modules = {
          level: { title: 'Level Matching', difficulty: 'Foundation', description: 'Learn why louder often sounds “better” and practice comparing at matched playback levels.', prompt: 'Which sample is actually louder—and which only sounds more exciting?', listen: 'Listen for overall energy before focusing on bass or treble.', skill: 'Comparison discipline' },
          location: { title: 'Frequency Location', difficulty: 'Foundation', description: 'Connect broad frequency regions to familiar musical cues without memorizing test-tone numbers.', prompt: 'Did the change happen in bass weight, vocal presence, or top-end air?', listen: 'Use the musical object first, then name the frequency region.', skill: 'Frequency vocabulary' },
          stereo: { title: 'Stereo Position', difficulty: 'Foundation', description: 'Practice placing a sound left, center, or right before moving into smaller positional differences.', prompt: 'Where does the sound sit relative to the center image?', listen: 'Anchor the center first, then judge lateral movement.', skill: 'Image stability' },
          bass: { title: 'Bass Control', difficulty: 'Focus', description: 'Separate bass quantity from bass texture, speed, and masking.', prompt: 'Which sample keeps the kick defined after the initial impact?', listen: 'Follow the decay after the hit instead of judging impact alone.', skill: 'Low-end control' },
          vocal: { title: 'Vocal Presence', difficulty: 'Focus', description: 'Hear the difference between natural vocal clarity, added warmth, and excessive forwardness.', prompt: 'Which sample moves the voice closer without making it strained?', listen: 'Compare chest tone, consonants, and distance together.', skill: 'Midrange balance' },
          treble: { title: 'Treble Texture', difficulty: 'Focus', description: 'Distinguish detail from sharpness by listening to decay, texture, and repeated transients.', prompt: 'Which sample reveals the cymbal texture without turning the edge brittle?', listen: 'Follow the shimmer after the strike, not only the first attack.', skill: 'High-frequency texture' },
          compression: { title: 'Dynamic Compression', difficulty: 'Reference', description: 'Identify when loud and quiet moments are pulled closer together.', prompt: 'Which sample preserves a greater difference between soft and loud passages?', listen: 'Compare the shape of the phrase, not only its peak volume.', skill: 'Dynamic contrast' },
          timbre: { title: 'Timbre Consistency', difficulty: 'Reference', description: 'Evaluate whether an instrument keeps a believable body, attack, and decay across its range.', prompt: 'Which sample keeps the piano sounding more like one coherent instrument?', listen: 'Notice whether low, middle, and high notes share the same material character.', skill: 'Naturalness' },
          imaging: { title: 'Imaging Precision', difficulty: 'Reference', description: 'Judge whether a sound has a stable point, a broad area, or an unstable position.', prompt: 'Which sample gives the source the clearest, most repeatable location?', listen: 'Repeat the comparison and check whether the position stays consistent.', skill: 'Spatial precision' }
        };
        var step = 0;
        var selectModule = function (id) {
          step = 0;
          var m = modules[id];
          if (!m) return;
          $$('.ke-lesson-button').forEach(function (b) { b.classList.toggle('active', b.dataset.module === id); });
          $('#lessonTitle').textContent = m.title;
          $('#lessonDescription').textContent = m.description;
          $('#lessonPrompt').textContent = m.prompt;
          $('#lessonListen').textContent = m.listen;
          $('#lessonDifficulty').textContent = m.difficulty;
          $('#lessonSkill').textContent = m.skill;
          updateSteps();
        };
        var updateSteps = function () {
          var labels = ['Preview A', 'Preview B', 'Make a choice', 'Read the cue'];
          $$('.ke-training-step').forEach(function (el, i) { el.classList.toggle('active', i <= step); });
          $('#walkthroughButton').textContent = step >= 3 ? 'Restart walkthrough' : labels[step + 1] || labels[0];
          $('#trainingPhase').textContent = labels[step];
        };
        $$('.ke-lesson-button').forEach(function (btn) {
          btn.addEventListener('click', function () { selectModule(btn.dataset.module); });
        });
        $$('.ke-track-tabs button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var track = btn.dataset.track;
            $$('.ke-track-tabs button').forEach(function (b) { b.classList.toggle('active', b === btn); });
            $$('.ke-lesson-button').forEach(function (b) { b.hidden = b.dataset.track !== track; });
            var first = $('.ke-lesson-button[data-track="' + track + '"]');
            if (first) selectModule(first.dataset.module);
          });
        });
        var walk = $('#walkthroughButton');
        if (walk) walk.addEventListener('click', function () {
          step = step >= 3 ? 0 : step + 1;
          updateSteps();
        });
        selectModule('level');
      }

      /* ---- EQ Playground: presets + six sliders drive the SVG curve,
             band readout, reset, and per-browser save. Visual only. ---- */
      if (page === 'eq') {
        var bands = [
          { id: 'sub', name: 'Sub-bass', range: '20–60 Hz', help: 'Rumble, extension, and physical scale. Too much can overpower the rest of the mix.' },
          { id: 'midbass', name: 'Mid-bass', range: '60–250 Hz', help: 'Punch, warmth, and rhythmic weight. Too much can make bass feel thick or slow.' },
          { id: 'lowmids', name: 'Lower mids', range: '250 Hz–1 kHz', help: 'Body in voices and instruments. Too little can sound thin; too much can sound congested.' },
          { id: 'upmids', name: 'Upper mids', range: '1–4 kHz', help: 'Presence, clarity, and articulation. Too much can sound shouty or intense.' },
          { id: 'treble', name: 'Treble', range: '4–10 kHz', help: 'Attack, edge definition, and perceived detail. Too much can sound sharp or sibilant.' },
          { id: 'air', name: 'Air', range: '10–20 kHz', help: 'Openness, shimmer, and upper-harmonic space. Perception varies strongly by fit and hearing.' }
        ];
        var eqPresets = { flat: [0, 0, 0, 0, 0, 0], balanced: [2, 1, 0, 1, 1, 1], powerful: [5, 4, 0, 1, 1, 0], vocal: [0, -1, 1, 4, 1, 1], warm: [2, 3, 2, 0, -1, -2], spacious: [0, -1, 0, 1, 2, 5] };
        var gains = [0, 0, 0, 0, 0, 0];
        var activeBand = 0;
        var xs = [70, 184, 298, 412, 526, 640], baseline = 178, scale = 17;
        var smoothPath = function (points) {
          if (points.length < 2) return '';
          var d = 'M ' + points[0][0] + ' ' + points[0][1];
          for (var i = 0; i < points.length - 1; i++) {
            var p0 = points[i - 1] || points[i], p1 = points[i], p2 = points[i + 1], p3 = points[i + 2] || p2;
            var cp1x = p1[0] + (p2[0] - p0[0]) / 6, cp1y = p1[1] + (p2[1] - p0[1]) / 6;
            var cp2x = p2[0] - (p3[0] - p1[0]) / 6, cp2y = p2[1] - (p3[1] - p1[1]) / 6;
            d += ' C ' + cp1x.toFixed(1) + ' ' + cp1y.toFixed(1) + ', ' + cp2x.toFixed(1) + ' ' + cp2y.toFixed(1) + ', ' + p2[0] + ' ' + p2[1];
          }
          return d;
        };
        var nearestPreset = function () {
          var best = 'Custom', score = Infinity;
          Object.keys(eqPresets).forEach(function (name) {
            var vals = eqPresets[name];
            var s = vals.reduce(function (a, v, i) { return a + Math.pow(v - gains[i], 2); }, 0);
            if (s < score) { score = s; best = name.charAt(0).toUpperCase() + name.slice(1); }
          });
          return score < 2.5 ? best : 'Custom curve';
        };
        var updateEq = function () {
          var pts = gains.map(function (g, i) { return [xs[i], baseline - g * scale]; });
          var d = smoothPath(pts);
          $('#eqLine').setAttribute('d', d);
          $('#eqGlow').setAttribute('d', d);
          $('#eqArea').setAttribute('d', d + ' L ' + xs[xs.length - 1] + ' ' + baseline + ' L ' + xs[0] + ' ' + baseline + ' Z');
          $$('.ke-eq-point').forEach(function (p, i) { p.setAttribute('cx', xs[i]); p.setAttribute('cy', baseline - gains[i] * scale); });
          bands.forEach(function (b, i) {
            var r = $('#eq-' + b.id), o = $('#out-' + b.id);
            if (r) r.value = gains[i];
            if (o) o.textContent = (gains[i] > 0 ? '+' : '') + gains[i] + ' dB';
          });
          var band = bands[activeBand], gain = gains[activeBand];
          $('#bandReadoutTitle').textContent = band.name + ' · ' + band.range;
          $('#bandReadoutText').textContent = band.help;
          $('#gainValue').textContent = (gain > 0 ? '+' : '') + gain + ' dB';
          var near = nearestPreset();
          $('#curveName').textContent = near;
          $$('.ke-eq-preset').forEach(function (btn) { btn.classList.toggle('active', btn.dataset.preset.toLowerCase() === near.toLowerCase()); });
        };
        bands.forEach(function (b, i) {
          var range = $('#eq-' + b.id), label = $('[data-band-index="' + i + '"]');
          if (range) {
            range.addEventListener('input', function () { gains[i] = Number(range.value); activeBand = i; updateEq(); });
            range.addEventListener('focus', function () { activeBand = i; updateEq(); });
          }
          if (label) label.addEventListener('click', function () { activeBand = i; if (range) range.focus(); updateEq(); });
        });
        $$('.ke-eq-preset').forEach(function (btn) {
          btn.addEventListener('click', function () { gains = eqPresets[btn.dataset.preset].slice(); activeBand = 0; updateEq(); });
        });
        var reset = $('#resetEq');
        if (reset) reset.addEventListener('click', function () { gains = eqPresets.flat.slice(); activeBand = 0; updateEq(); showToast('Curve reset.'); });
        var save = $('#saveEq');
        if (save) save.addEventListener('click', function () {
          try { localStorage.setItem('keEqCurve', JSON.stringify(gains)); } catch (err) {}
          showToast('Curve saved in this browser.');
        });
        var saved = null;
        try { saved = localStorage.getItem('keEqCurve'); } catch (err) {}
        if (saved) {
          try {
            var parsed = JSON.parse(saved);
            if (Array.isArray(parsed) && parsed.length === 6) gains = parsed.map(Number);
          } catch (e) {}
        }
        updateEq();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
